import { useCallback } from 'react'
import { pickLocalized } from '../game/localized'
import type { LocalizedText } from '../game/types'
import { useGameStore } from '../store/useGameStore'
import { formatDateTime, formatDateTimeShort, formatDurationMs } from './format'
import type { MessageKey } from './messages'
import { translateStatic } from './translate'

export function useI18n() {
  const language = useGameStore((s) => s.settings.language)

  const t = useCallback(
    (key: MessageKey, params?: Record<string, string | number>) =>
      translateStatic(language, key, params),
    [language],
  )

  const pick = useCallback(
    (text: LocalizedText) => pickLocalized(text, language),
    [language],
  )

  const formatDateTimeLocalized = useCallback(
    (value: number | Date) => formatDateTime(language, value),
    [language],
  )

  const formatDateTimeShortLocalized = useCallback(
    (value: number | Date) => formatDateTimeShort(language, value),
    [language],
  )

  const formatDurationMsLocalized = useCallback(
    (ms: number) => formatDurationMs(language, ms),
    [language],
  )

  return {
    language,
    t,
    pick,
    formatDateTime: formatDateTimeLocalized,
    formatDateTimeShort: formatDateTimeShortLocalized,
    formatDurationMs: formatDurationMsLocalized,
  }
}

export { translateStatic } from './translate'
export type { MessageKey } from './messages'
